// extracted by mini-css-extract-plugin
module.exports = {"term":"Term_term__C4Hry","term__link":"Term_term__link__Rv4co","term__ellipsis":"Term_term__ellipsis__1Bena"};